import { Injectable } from '@angular/core';

import { AdvisoryModel } from '../data';
import { MemoryCacheRepository } from './memory-cache.repository';

@Injectable()
export class AdvisoryModelCacheRepository extends MemoryCacheRepository<AdvisoryModel[]> {}
